import { render, staticRenderFns } from "./DashboardKnowledgePanel.vue?vue&type=template&id=622df500&scoped=true"
import script from "./DashboardKnowledgePanel.vue?vue&type=script&lang=js"
export * from "./DashboardKnowledgePanel.vue?vue&type=script&lang=js"
import style0 from "./DashboardKnowledgePanel.vue?vue&type=style&index=0&id=622df500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622df500",
  null
  
)

export default component.exports